function searchProductsByType(type) {
  $.ajax({
    url: 'https://reco-9753.myshopify.com/api/graphql',
    method: 'POST',
    headers: {
        'X-Shopify-Storefront-Access-Token': '9100a02e1683fc7c3c5d0b13437d1832',
        'Content-Type': 'application/graphql',
    },
    data: `query {
      products(first:30, query: "product_type:'` + type + `'"){
        edges {
          node {
            id
            title
            productType
            handle
            metafield1: metafield(key:"color_image", namespace:"custom"){
              value
            }
            metafield2: metafield(key:"couleur", namespace:"custom"){
              value
            }
            metafield3: metafield(key:"coloris", namespace:"custom"){
              value
            }
          }
        }
      }
    }`,
  })
  .done(function(data) {
    if (!data.data.products) {
      $('.color-selector').remove();
    } else {
      $('.color-selector a').remove();
      
      var edges = data.data.products.edges;
      var j, product, handle, url, metas, mColoris, mCouleur;
      
      for (var i=0; i<edges.length; i++) {
        product = edges[i].node;
        id = product.id;
        title = product.title;
        handle = product.handle;
        product_type = product.productType;
        //url = product.onlineStoreUrl;
        
        if (handle && product_type == productType) {
          sHtmlMeta = sHtmlClass = mImage = mColoris = mCouleur = '';

          if (product.metafield1) mImage = product.metafield1.value;
          if (product.metafield2) mCouleur = product.metafield2.value;
          if (product.metafield3) mColoris = product.metafield3.value;

          if (mImage != '') {
            sHtmlClass = ' load-color-image';
            sHtmlMeta = 'data-product-id="' + id + '"';
          } else if (mCouleur != '') sHtmlMeta = 'style="background-color:' + mCouleur + '"';
          else if (mColoris != '') sHtmlMeta = 'style="background-color:' + (oProductSwatchColors[mColoris] ? oProductSwatchColors[mColoris] : '#ddd') + '"';
          else sHtmlMeta = 'style="background-color:#ddd"';

          $('.color-selector').append('<a href="/products/' + handle + '" class="color-variant' + sHtmlClass + (handle == productHandle ? ' active' : '') + '" title="' + title + '" ' + sHtmlMeta + '></a>');
        }
      }

      $('.color-selector .color-variant.load-color-image').each(function(i){
        getProductColorImageSrc($(this));
      });
    }
  });
}

function getProductColorImageSrc(target) {
  var id = target.data("product-id");
  var decoded = atob(id);
  var shopifyId = decoded.split("/").pop();
  var cleanId =  parseInt(shopifyId);
  
  $.ajax({
    url: 'https://reco-9753.myshopify.com/api/graphql',
    method: 'POST',
    headers: {
        'X-Shopify-Storefront-Access-Token': '9100a02e1683fc7c3c5d0b13437d1832',
        'Content-Type': 'application/graphql',
    },
    data: `query {
      product(id: "gid://shopify/Product/` + cleanId + `") {
        id
        metafield(namespace: "custom", key: "color_image") {
          reference {
            ... on MediaImage {
              id
              image {
                originalSrc
              }
            }
          }
        }
      }
    }`,
  })
  .done(function(data) {
    if (data.data.product) {
      id = data.data.product.id;
      src = data.data.product.metafield.reference.image.originalSrc;

      $('.color-selector .color-variant.load-color-image[data-product-id="' + id + '"]').css({'background-image': 'url("' + src + '")'});
    }
  });
}

$(document).ready(function(){
  searchProductsByType(productType);
});